export default __webpack_public_path__ + "images/c34175f1037ccb835f7857cf02af38a4-government.jpg";